"use strict";

export const LANGUAGES = [
  {
    flag: "us",
    language: "en",
    title: "English",
  },
  {
    flag: "hk",
    language: "zh",
    title: "中文",
  },
];
